export default "__VITE_ASSET__8567ac08__"